// extracted by mini-css-extract-plugin
export var socialLinks = "styles-module--socialLinks--g3InF";